class KotoyokuBtn {
  
    constructor() {
        this.btns = document.querySelectorAll('.kotoyoku');
        this.iteminputs = document.querySelectorAll('.iteminputs'); 
        this.addbtns = document.querySelectorAll('.addbtn');
        this.minusbtns = document.querySelectorAll('.minusbtn');
        this.addcartbtns = document.querySelectorAll('.addcartbtn');
        
        this.init();
    }

    init() {
        this.addcartbtns.forEach((btn, index) => {
            btn.addEventListener('click', () => {
                this.handleAddToCart(btn, index);
            });
        });

        this.btns.forEach((btn, index) => {
            btn.addEventListener('click', () => {
                this.handleAddToCart(btn, index);
            });
        });

        this.addbtns.forEach((btn, index) => {
            btn.addEventListener('click', () => {
                this.Add_Count(index);
            });
        });

        this.minusbtns.forEach((btn, index) => {
            btn.addEventListener('click', () => {
                this.Minus_Count(index);
            });
        });

        this.iteminputs.forEach((btn, index) => {
            btn.addEventListener('change', () => {
                this.Input_check(index);
            });
        }); 

      　this.Init_AddItem();
    }

    Add_Count(index){
        this.iteminputs[index].value ++;
    }

    Minus_Count(index){
        this.iteminputs[index].value = Math.max(1, this.iteminputs[index].value - 1);
    }

    Input_check(index) {
        if (this.iteminputs[index].value < 1) {
            this.iteminputs[index].value = 1;
        }
    }    

    Init_AddItem() {
        let Item = localStorage.getItem("AddItem")
        let Count = localStorage.getItem("AddCount")
        if (Item) {
            alert(Item + "を" + Count + "個カートに追加しました。");
            localStorage.removeItem("AddItem");
            localStorage.removeItem("CountItem");
        }
    }

    async handleAddToCart(button, index) {
      
        const variantId = button.dataset.variantid;
        const formData = {
            items: [
                {
                    id: variantId,
                    quantity: this.iteminputs[index].value,
                    properties: {}
                }
            ]
        };
        try {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {'dataType': 'json','Content-Type': 'application/json'},
                body: JSON.stringify(formData)
            });
        } catch (error) {
            console.error('Error:', error);
        }
        this.add_localStorage(index, this.iteminputs[index].value);
    }

    add_localStorage(index, count) {
        let button = this.btns[index];
        let title = button.getElementsByClassName("kotoyoku-title")[0].innerHTML;
        localStorage.setItem("AddItem", title);
        localStorage.setItem("AddCount", count);
        window.location.reload(true);
    }
  
}

class Filterbtn {
  
    constructor() {
        this.btns = document.querySelectorAll('.filter');
        this.init();
    }

    init() {
        this.btns.forEach(btn => {
            btn.addEventListener('click', () => {
                this.FilterItem(btn);
            });
        });
    }

    
    FilterItem(button) {

        // フィルターボタンの色設定
        this.btns.forEach(btn => {
          if (button.dataset.type != btn.dataset.type) { 
            btn.classList.remove("bg_bk", "white");
          }
        });              
        button.classList.toggle("bg_bk");
　　　　button.classList.toggle("white");

        // アイテムをフィルタリングする
        let btna = document.querySelectorAll('.kotoyoku-wrap');
        for (const btn of btna) {
            if (btn.dataset.type != button.dataset.type) {
               btn.classList.toggle("inp_hidden");
            } else if (btn.classList.contains("inp_hidden")) {
                btn.classList.remove("inp_hidden");
            }
        }
      
    }
  
}

document.addEventListener('DOMContentLoaded', function() {
    new KotoyokuBtn();
    new Filterbtn();
});
